import { Form, Input, Checkbox, FormProps, Select, FormInstance, Tabs } from "antd";
import TabPane from "antd/es/tabs/TabPane";

import { ChildForm, FieldDB, TabForm } from 'interfaces/schemaDB';
import { CrudFilters, CrudFilter, ConditionalFilter, LogicalFilter } from '@refinedev/core/dist/interfaces';
import Cw8Field from './Cw8Field';

// import {  } from '@refinedev/core/dist/interfaces';
// import { CrudFilter } from '@refinedev/core';
import { FormMode, ProviderTypes } from '../../../src/interfaces/interfaces';
// import moment from "moment-timezone";
import moment from 'moment'
import { config } from "config";
import Cw8List from "./Cw8List";
import Cw8FieldsForm from "./Cw8FieldsForm";
import { BaseKey } from '@refinedev/core';


interface Cw8TabProps{
    fieldList: FieldDB[]
    tabs : TabForm[] 
    formMode : FormMode
    filterList?: CrudFilters | undefined
    record?: unknown
    resourceName : string
    form : FormInstance
    childrenForms?: ChildForm[]
    id?:string | BaseKey

}


const Cw8TabsForm = ({fieldList, tabs, filterList, record, formMode, resourceName, form, childrenForms, id}: Cw8TabProps ) => {


    const idTabs: string[] = tabs?.map((tab) => tab.id);
    const otherFields = fieldList.filter( field => !field.idTab || !idTabs.includes(field.idTab) )

// console.log(record)

    return(
        <>

            <Tabs defaultActiveKey="0" >

                {
                    tabs?.map( (tab,idx) =>(
                        <TabPane tab={tab.title} key={idx}>
                            {/* <Cw8Edit resourceName = {resourceName}  childrenForms={childrenForms}></Cw8Edit> */}

                            <Cw8FieldsForm
                                fieldList = {fieldList.filter(field => field.idTab === tab.id)}
                                filterList = {filterList}
                                record = {record}
                                formMode = {formMode}
                                resourceName = {resourceName}
                                form = {form}                        
                            ></Cw8FieldsForm>
                        </TabPane>
                    ))
                }

                {
                    otherFields.length>0?(
                        <TabPane tab={"Otros"} key={100}>
                            {/* <Cw8Edit resourceName = {resourceName}  childrenForms={childrenForms}></Cw8Edit> */}

                            <Cw8FieldsForm
                            
                                fieldList = {otherFields}
                                filterList = {filterList}
                                record = {record}
                                formMode = {formMode}
                                resourceName = {resourceName}
                                form = {form}                        
                            ></Cw8FieldsForm>
                        </TabPane>            
                    ):null
                }

                {
                    childrenForms?childrenForms.filter( item => !item.url ).map( (child, index) =>(
                        <TabPane tab={child.title} key={index+20}>
                            <Cw8List
                                resourceName = {child.resourceName}
                                titleList = {child.title}
                                filterList ={[
                                    {
                                        // field: child.field,
                                        // operator: "eq",
                                        // value: id
                                        field: child.field,
                                        operator: "eq",
                                        value: id /* AQUI SE DEBE ASOCIAR CON EL id DEL REGISTRO QUE SE ESTA EDITANDO*/ 
                                    }
                                ]}
                                showCards = {child.showCards?true:false}
                                configCard = {
                                    child.configCard?child.configCard:undefined
                                }

                                createModal ={true}
                                editModal = {true}
                            ></Cw8List>        
                        </TabPane>

                    )):null
                }

            </Tabs>
        </>
    )
}


export default Cw8TabsForm